"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _RadioGroup = _interopRequireDefault(require("@material-ui/core/RadioGroup"));

var _CheckBox = _interopRequireDefault(require("@material-ui/icons/CheckBox"));

var _Headline = _interopRequireDefault(require("@jobmatchme/ui/es/components/Headline"));

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/Button"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _ModalDialog = _interopRequireDefault(require("@jobmatchme/ui/es/components/ModalDialog"));

var _Authentication = require("../../provider/Authentication");

var _CheckBoxOutlineBlank = _interopRequireDefault(require("@material-ui/icons/CheckBoxOutlineBlank"));

var _trackingService = require("@jobmatchme/frontend-analytics/es/trackingService.js");

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DislikeQuestion = function DislikeQuestion(_ref) {
  var t = _ref.t,
      translateNs = _ref.translateNs,
      openDialog = _ref.openDialog,
      closeForm = _ref.closeForm;
  var answers = [];
  var status = 'Accepted';

  var _useContext = (0, _react.useContext)(_Authentication.AuthenticationContext),
      user = _useContext.user;

  var DialogActions = function DialogActions() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
      container: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
        item: true,
        xs: 12,
        alignContent: "center",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Headline.default, {
          variant: 3,
          size: 3,
          className: _styleModule.default.questionHeadline,
          children: t("".concat(translateNs, ".deactivationDialog.description"))
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ChoiceComponent, {})]
      })
    });
  };

  var handleClick = function handleClick(event) {
    var value = event.target.value;

    if (event.target.checked) {
      answers.push(value);
    } else {
      answers = answers.filter(function (v) {
        return v !== value;
      });
    }
  };

  var handleClose = function handleClose() {
    status = 'Closed';
    sendData();
    closeForm();
  };

  var sendData = function sendData() {
    (0, _trackingService.trackEvent)({
      eventName: 'jmmJudgementAccountDeactivation',
      pcUuid: user.username,
      payload: {
        answers: answers || null,
        status: status
      }
    });
    closeForm();
  };

  var Choice = function Choice(_ref2) {
    var option = _ref2.option,
        translation = _ref2.translation,
        valueName = _ref2.valueName;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlLabel.default, {
      value: option,
      className: _styleModule.default.formControlLabel,
      onChange: handleClick,
      labelPlacement: "end",
      control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.default, {
        className: _styleModule.default.radioBtn,
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBoxOutlineBlank.default, {
          className: _styleModule.default.sizeIconEmpty
        }),
        checkedIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBox.default, {
          className: _styleModule.default.sizeIconChecked,
          color: "primary"
        })
      }, valueName),
      label: translation
    });
  };

  var ChoiceComponent = function ChoiceComponent() {
    var list = [];
    var sections = {
      answ1: t("".concat(translateNs, ".deactivationDialog.q1")),
      answ2: t("".concat(translateNs, ".deactivationDialog.q2")),
      answ3: t("".concat(translateNs, ".deactivationDialog.q3")),
      answ4: t("".concat(translateNs, ".deactivationDialog.q4")),
      answ5: t("".concat(translateNs, ".deactivationDialog.q5"))
    };

    var GetList = function GetList() {
      Object.keys(sections).forEach(function (key) {
        list.push( /*#__PURE__*/(0, _jsxRuntime.jsx)(Choice, {
          option: sections[key],
          translation: sections[key],
          valueName: sections[key]
        }));
      });
      return list;
    };

    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
      container: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RadioGroup.default, {
        "aria-label": 'questions',
        name: 'questions',
        value: 'val',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(GetList, {})
      })
    });
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalDialog.default, {
    id: 'questionDialog',
    title: t("".concat(translateNs, ".deactivationDialog.title")),
    verticalMobilePosition: 'bottom',
    onClose: handleClose,
    showDividers: true,
    open: openDialog,
    opacity: 0.5,
    dialogActions: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      className: _styleModule.default.btnPos,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        color: "success",
        variant: "contained",
        round: true,
        flat: true,
        extraBold: true,
        texttransform: "none",
        onClick: sendData,
        children: t("".concat(translateNs, ".deactivationDialog.btn"))
      })
    }),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(DialogActions, {})
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(DislikeQuestion);

exports.default = _default;